<template>
	<type-wrapper class="find_orders" limit>
		<type-grid row="2" margin>
			<type-image mode="widthFix" :src="image"></type-image>
		</type-grid>
		<type-grid row="2" margin>
			<type-grid row="1" margin>
				<type-title medium weight="normal">
					查找订单
				</type-title>
			</type-grid>
			<type-grid row="1" margin>
				<type-input whitebackdrop clearable v-model="email" placeholder="邮箱地址"></type-input>
			</type-grid>
			<type-grid row="1" margin>
				<type-input whitebackdrop clearable v-model="order" placeholder="订单号"></type-input>
			</type-grid>
			<type-grid row="1" margin>
				<type-button whitebackdrop border @click="findOrder">查找</type-button>
			</type-grid>
			<type-grid row="1" margin v-if="orderList.length">
				<div id="order-html">
					<div class="single-order" v-for="(item, index) in orderList" :key="index">
						<h6>订单 {{index + 1}}</h6>
						<p>订单号: {{item.order_unique_id}}</p>
						<p>商品名称: {{item.product_name}}</p>
						<p>商品信息: {{item.product_description}}</p>
						<p>商品数量: {{item.quantity}}</p>
						<p>商品单价: {{item.final_price}}</p>
						<p>买家姓名: {{item.receiver_name}}</p>
					</div>
				</div>
			</type-grid>
			<type-grid row="1" margin v-if="orderList.length">
				<type-button whitebackdrop v-print="'#order-html'" border>打印订单</type-button>
			</type-grid>
		</type-grid>
	</type-wrapper>
</template>

<script>
	export default {
		name: 'find_orders',
		data() {
			return {
                email: '',
                order: '',
				// email: '123@qq.com',
				// order: '2020031810210198',
				orderList: [
					// {
					// 	order_unique_id: 1,
					// 	product_name: 'xaxasdasdas',
					// 	product_description: 'xaxasdasdas',
					// 	quantity: 'xaxasdasdas',
					// 	final_price: 'xaxasdasdas',
					// 	receiver_name: 'xaxasdasdas'
					// },
					// {
					// 	order_unique_id: 2,
					// 	product_name: 'xaxasdasdas',
					// 	product_description: 'xaxasdasdas',
					// 	quantity: 'xaxasdasdas',
					// 	final_price: 'xaxasdasdas',
					// 	receiver_name: 'xaxasdasdas'
					// }
				],
				image: require('../../assets/image/about-img.jpg')
			}
		},
		methods: {
			findOrder() {
				if (!this.email && !this.order) {
					this.$message('请输入邮箱地址或订单号');
					return false;
				}
				if (this.email && (this.$verify.verifyEmail(this.email) !== true)) {
					this.$message('请输入正确的邮箱地址');
					return false;
				}
				const req = Object.create(null);
				this.orderList = [];
				if (this.email) {
					req.customer_email = this.email;
				}
				if (this.order) {
					req.order_unique_id = this.order;
				}
                // 输入邮箱找不到，只输入订单号找得到
				console.log(JSON.parse(JSON.stringify(req)))
				this.$http.order.lists(req).then(res => {
					console.log(JSON.parse(JSON.stringify(res)))
					if (res.status === 'success') {
						if (res.data.list.length) {
						    this.orderList = res.data.list;
						} else {
						    this.$message('暂无订单信息');
						}
					}
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.find_orders{
		display: flex;
		flex-wrap: wrap;
        .single-order h6{
        	padding: 10px 0 5px;
        	font-weight: normal;
        }
        .single-order p{
        	color: #979797;
        	font-size: 13.5px;
        	line-height: 25px;
        	padding-bottom: 5px;
        }
	}
</style>